import { actionTypes } from '../constants/actionTypes';

export const authToken = (state = '', action) => {
  switch (action.type) {
    case actionTypes.SET_AUTH_TOKEN:
      return action.payload;
  }

  return state;
};

export const locale = (state = '', action) => {
  switch (action.type) {
    case actionTypes.SET_LOCALE:
      return action.payload;
  }

  return state;
};

export const environment = (state = '') => {
  return state;
};

export const apiTimeOut = (state = '') => {
  return state;
};

export const victoriesHeaderPath = (state = '') => {
  return state;
};

export const perfAPI = (state = '') => {
  return state;
};

export const translationApiUrl = (state = '') => {
  return state;
};

export const dateDisplayTimezone = (state = '') => {
  return state;
};
